<!-- FACTURA -->
<fieldset class="upload-container">
    <div class="upload-header">
        <label for="upload-field" class="upload-title">Factura:</label>
        <p class="upload-subtitle">Si no puedes ahora, tranqui, más adelante te la pediremos.
        </p>
    </div>

    @if (uploadedFiles().length === 0 && !isDragging()) {
    <!-- Estado inicial: zona de drag & drop -->
    <div class="upload-zone" [class.dragging]="isDragging()" (click)="fileInput.click()"
        (keydown.enter)="fileInput.click()" (keydown.space)="$event.preventDefault(); fileInput.click()" tabindex="0"
        role="button" aria-label="Seleccionar o arrastrar archivo" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">


        <span class="upload-text">
            <strong>Arrastra tu archivo aquí</strong>
            <p class="upload-subtext">o haz clic para seleccionar</p>
            <p class="upload-formats">PDF, PNG, JPEG</p>
        </span>




        <div class="upload-icon">
            <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
        </div>

    </div>
    }

    @if (isDragging()) {
    <!-- Estado de arrastre activo -->
    <div class="upload-zone dragging-active" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">

        <div class="upload-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
        </div>

        <p class="upload-text">
            <strong>Suelta el archivo aquí</strong>
        </p>
    </div>
    }

    <!-- Archivos subiendo o completados -->
    @if (uploadedFiles().length > 0) {
    <div class="files-section">
        <h4 class="files-title">*Documentos cargados</h4>

        <div class="files-list">
            @for (file of uploadedFiles(); track file.id) {
            <div class="file-item" [class.uploading]="file.status === 'uploading'">

                @if (file.status === 'uploading') {
                <!-- Archivo subiendo con progress bar -->
                <div class="file-info">
                    <span class="file-name">{{ file.name }}</span>
                    <button type="button" class="file-cancel" (click)="cancelUpload(file.id)"
                        aria-label="Cancelar carga">
                        ✕
                    </button>
                </div>
                <div class="progress-bar">
                    <div class="progress-fill" [style.width.%]="file.progress"></div>
                </div>
                <span class="upload-status">Subiendo...</span>
                }

                @if (file.status === 'completed') {
                <!-- Archivo completado -->
                <div class="file-completed">
                    <span class="file-badge">{{ file.name }}</span>
                    <button type="button" class="file-delete" (click)="removeFile(file.id)"
                        aria-label="Eliminar archivo">
                        <img src="./assets/img/svg/Basurero_azul.svg" alt="clear" title="clear-icon" srcset="">
                    </button>
                </div>
                }

                @if (file.status === 'error') {
                <!-- Archivo con error -->
                <div class="file-error">
                    <span class="file-name-error">{{ file.name }}</span>
                    <span class="error-message">{{ file.errorMessage }}</span>
                    <button type="button" class="file-delete" (click)="removeFile(file.id)"
                        aria-label="Eliminar archivo">
                        ✕
                    </button>
                </div>
                }
            </div>
            }
        </div>

        <!-- Botón para agregar más archivos -->
        @if (hasCompletedFiles()) {
        <button type="button" class="add-more-btn" (click)="fileInput.click()">
            + Agregar otro documento
        </button>
        }
    </div>
    }

    <!-- Input file oculto -->
    <input #fileInput type="file" multiple accept=".pdf,.png,.jpg,.jpeg" (change)="onFileSelected($event)"
        style="display: none;">

    @if (errorMessage()) {
    <div class="alert-error">
        <span class="alert-icon">⚠️</span>
        <span>{{ errorMessage() }}</span>
    </div>
    }




</fieldset>